import {  Grid, GridColumn as Column,GridCellProps, GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import React, { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { Profile } from "../../../../services/profileService";
import {toggleClaimAccessModal} from '../../../../app/slices/ProfileModuleSlice';
import { process, State } from "@progress/kendo-data-query";
import { useClaimsQuery } from "../../../../services/profileService/profile-api";
import { ColumnMenu } from "../../../../utils/ColumnMenu";
import { ClaimAccessEditCommandCell } from "./ClaimAccessEditCommand";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";

type ownProps ={
    profile:Profile;
}

function ClaimAccessEdit(props:ownProps){
    const modalOpen = useAppSelector((state)=>state.profileModule.claimAccessModal);
    const dispatch = useAppDispatch();
    const {data} = useClaimsQuery();
    const [dataState, setDataState] = useState<State>({});
    const [profile] = useState(props.profile);
    const createDataState = (dataState: State) => {
        return {
          dataState: dataState === undefined ? {} :dataState,};
      }; 
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        let updatedState = createDataState(event.dataState);
        setDataState(updatedState.dataState);
      };
      const customEditCell = (props:GridCellProps) => (<ClaimAccessEditCommandCell {...props} profile = {profile}/>)
    return <React.Fragment>
        <Dialog open={modalOpen} maxWidth='lg'>
            <DialogTitle>Add Claims</DialogTitle>    
            <DialogContent className='card-body-grid'>
                <Grid className="center-list-grid embedded-grid" data={process(data === undefined ? [] : data.slice(0),dataState)}{...dataState} style={{height:'500px'}}
                    onDataStateChange={dataStateChange}>
                        <Column cell={customEditCell} width='100px'/>
                        <Column title='Code' field='claimValue' columnMenu={ColumnMenu}/>
                        <Column title='Name' field="claimName" columnMenu={ColumnMenu}/>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Stack direction='row' justifyContent='flex-end'>
                    <Button variant="outlined" onClick={()=>dispatch(toggleClaimAccessModal())}>Close</Button>
                </Stack>
            </DialogActions>
        </Dialog>    
    </React.Fragment>
}

export {ClaimAccessEdit}

